
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produkt/[[...slug]]",
      function () {
        return require("private-next-pages/produkt/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produkt/[[...slug]]"])
      });
    }
  